import config from '../../../config';

const baseUrl = `${config.apiUrl(1)}/SignUpAttempts`;

export default {
  baseUrl: (): string => `${baseUrl}`,
};
